<div class="relative elevation-1 border-b surface-container">


<mat-toolbar color="primary" class="flex flex-row justify-between items-center gap-3">
  
  @if (showBrand) {
    
    <div>
      <a routerLink="/">

        <img src="/icon.svg" alt="Looped In Logo" class="h-8 w-auto mr-3 inline-block">

        <strong>Looped In</strong>
      </a>
    </div>
  }

  <div class="flex flex-row gap-6 items-center">

    <!--
    <a  mat-icon-button (click)="toggleDisplayMode()">
      <fa-icon icon="circle-half-stroke"></fa-icon>
    </a>
    -->

    @if (!loading() && user()) {
      <div>
        <a [matMenuTriggerFor]="userMenu" class="cursor-pointer flex flex-row items-center gap-1">
          <app-avatar [user]="user()" size="xs" ></app-avatar>
          <fa-icon icon="caret-down"></fa-icon>
        </a>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="editProfile()">Edit profile</button>
          <button mat-menu-item (click)="signOut()">Sign out</button>
        </mat-menu>
      </div>
    }

    @if (!loading() && !user()) {
      <div class="flex flex-row gap-3">
        <button mat-button color='primary' (click)="signIn()">Sign In / Sign Up</button>
      </div>
    }

  </div>

</mat-toolbar>
</div>